import { api } from "./api"

export const getUfs = (numeroPagina: string) => api.get(`Uf/buscartodos/${numeroPagina}`)
export const getUf = (cdUf: number) => api.get(`Uf/buscar/${cdUf}`);
